import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";

const TbCtaBanner: React.FC = () => {
  return (
    <section className="wdev-cta tb-cta" aria-labelledby="tb-cta-title">
      <div className="container">
        <AnimatedSection>
          <motion.div className="wdev-cta__inner" whileHover={{ scale: 1.005 }} transition={{ duration: 0.3 }}>
            <div className="wdev-cta__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M5 17h14l-1-5H6l-1 5Z"
                  stroke="#2563eb"
                  strokeWidth="1.5"
                  strokeLinejoin="round"
                />
                <path d="M7 12V8a5 5 0 0 1 10 0v4" stroke="#2563eb" strokeWidth="1.5" />
                <circle cx="7.5" cy="17.5" r="1.5" fill="#2563eb" />
                <circle cx="16.5" cy="17.5" r="1.5" fill="#2563eb" />
              </svg>
            </div>
            <div className="wdev-cta__text">
              <h2 id="tb-cta-title" className="wdev-cta__title">
                Ready to Launch Your Taxi Business?
              </h2>
              <p className="wdev-cta__subtitle">
                Get a demo of our Uber/Ola clone — customer app, driver app, and admin panel included.
              </p>
            </div>
            <Link to="/contact" className="wdev-cta__btn">
              Ask for Demo
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path
                  d="M3 8h10M9 4l4 4-4 4"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </motion.div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default TbCtaBanner;
